import { Select } from '@trackman/web-shared-components';
import { AdminEventPlayerType } from 'types/admin/trackmanEventsAdmin';

const playerTypes = [
  { label: 'YouTube', value: 'Youtube' },
  { label: 'Vimeo', value: 'Vimeo' },
];

export const PlayerType = ({
  playerType,
  setPlayerType,
}: {
  playerType: AdminEventPlayerType;
  setPlayerType: (value: AdminEventPlayerType) => void;
}) => {
  return (
    <div className='admin-edit-section'>
      <h2>Player Type*</h2>
      <div className='inputs-container'>
        <Select
          label=''
          value={playerType || 'Youtube'}
          className='narrow-select'
          required
          onChange={(event) => setPlayerType(event.target.value as AdminEventPlayerType)}
          selectOptions={playerTypes.map((type) => {
            return {
              label: type.label,
              value: type.value,
            };
          })}
        />
      </div>
    </div>
  );
};
